/* Billing and the cashier (docs/plans/phase1-billing.md §6). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionHeading {
  font: var(--t-heading);
}

.summary {
  font: var(--t-body-strong);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 10rem;
  min-width: 0;
}

.queue {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--rule);
}

.queueItem {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-height: 44px;
  padding: var(--space-3) var(--space-2);
  border-bottom: 1px solid var(--rule);
  color: var(--ink);
  text-decoration: none;
}

.queueItem:hover {
  border-radius: var(--radius-control);
  background: var(--brand-tint);
}

/* The chosen item: a rounded fill in the strong primary tint; the text stays in place. */
.queueItem[aria-current='page'] {
  border-radius: var(--radius-control);
  background: var(--brand-tint-strong);
  font-weight: 500;
}

.queueItem:focus-visible {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.queueLine {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2);
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.queueHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-1) var(--space-3);
}

/* What the patient owes is the one number the cashier is looking for. */
.owed {
  font: var(--t-title);
  font-variant-numeric: tabular-nums;
}

/* The change to hand back, as cash is typed: large enough to read across the counter. */
.change {
  font: var(--t-title);
  font-variant-numeric: tabular-nums;
}

.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: var(--space-3);
  font: var(--t-body-strong);
}

/* A money field doesn't need the full form width. */
.narrowField {
  max-width: 20rem;
}

/* Approvals: one request after another, separated by rules; it works at phone width. */
/* Each request is its own card on the canvas (ADR 0017), so one decision reads as one unit. */
.requests {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.request {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  padding: var(--space-5);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--paper);
  box-shadow: var(--shadow-card);
}

@media (width < 640px) {
  .request {
    padding: var(--space-4);
  }
}

.actionCell {
  display: flex;
  flex-wrap: wrap;
  gap: 0 var(--space-2);
}

.tenders {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  border-top: 1px solid var(--rule);
}

.receiptPreview {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: flex-start;
}

/* A sheet that exists only to be printed: out of sight on screen, printed as normal. */
@media screen {
  .printOnly {
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
}
